import React from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import IndexTargetIncentive from "../payrollManagement/incentive/IndexTargetIncentive";
import IndexCaseSheet from "./caseSheet/IndexCaseSheet";
import IndexMyCaseSheet from "./caseSheet/IndexMyCaseSheet";
import IndexMySubordinateCaseSheet from "./caseSheet/IndexMySubordinateCaseSheet";
import IndexCaseSheetApprovals from "./caseSheet/IndexCaseSheetApprovals";

const TaskManagementModules = () => {

  const authUser = useSelector((state) => state.auth.authUser);
  return (
    <Routes>
      <Route path="caseTargetIncentive" element={ <IndexTargetIncentive modkey="case-target-incentive" /> } />
      <Route path="caseSheet" element={ <IndexCaseSheet modkey="case-sheet" /> } />
      <Route path="myCaseSheet" element={ <IndexMyCaseSheet modkey="my-case-sheet" /> } />
      <Route path="mySubordinateCaseSheet" element={ <IndexMySubordinateCaseSheet modkey="my-subordinate-case-sheet" /> } />
      <Route path="caseSheetApprovals" element={ <IndexCaseSheetApprovals modkey="case-sheet-approvals" /> } />


    </Routes>
  );
}

export default TaskManagementModules;